import React, { useEffect, useContext } from 'react'
import {
    Link,
} from "react-router-dom";
import { AuthContext } from '../contexts/AuthContext';

type Props = {}

const Sidebar = (props: Props) => {
    const { user } = useContext<any>(AuthContext)

    return (
    <aside id="sidebar" className="sidebar">
        <ul className="sidebar-nav" id="sidebar-nav">


            {(user.role == "admin" || user.role == "engineer")&& (
                <>
                <li className="nav-item">
                    <a className="nav-link collapsed" data-bs-target="#tables-nav" data-bs-toggle="collapse" href="#">
                        <i className="bi bi-layout-text-window-reverse"></i><span>Product Management</span><i className="bi bi-chevron-down ms-auto"></i>
                    </a>
                    <ul id="tables-nav" className="nav-content collapse " data-bs-parent="#sidebar-nav">
                        <li className="nav-item">
                            <Link  to={`/installationv2`} className="nav-link collapsed">
                                <i className="bi bi-lightbulb"></i><span>Installation</span>
                            </Link>
                        </li>
                        {/* <li className="nav-item">
                            <Link  to={`/simcard`} className="nav-link collapsed">
                                <i className="bi bi-circle"></i><span>Simcard</span>
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link  to={`/sensor`} className="nav-link collapsed">
                                <i className="bi bi-circle"></i><span>Sensor</span>
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link  to={`/pump`} className="nav-link collapsed">
                                <i className="bi bi-circle"></i><span>Pump</span>
                            </Link>
                        </li> */}
                        <li className="nav-item">
                            <Link  to={`/customer`} className="nav-link collapsed">
                                <i className="bi bi-circle"></i><span>Customer</span>
                            </Link>
                        </li>
                        {/* <li className="nav-item">
                            <Link  to={`/component`} className="nav-link collapsed">
                                <i className="bi bi-circle"></i><span>Component</span>
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link  to={`/som-passed`} className="nav-link collapsed">
                                <i className="bi bi-lightbulb"></i><span>SOM Passed</span>
                            </Link>
                        </li>*/}
                        
                        <li className="nav-item">
                            <Link  to={`/app-board-passed`} className="nav-link collapsed">
                                <i className="bi bi-lightbulb"></i><span>App Board Passed</span>
                            </Link>
                        </li> 
                    </ul>
                </li>

                

                <li className="nav-item">
                    <a className="nav-link collapsed" data-bs-target="#backend-management-nav" data-bs-toggle="collapse" href="#">
                        <i className="bi bi-layout-text-window-reverse"></i><span>Backend Management</span><i className="bi bi-chevron-down ms-auto"></i>
                    </a>
                    <ul id="backend-management-nav" className="nav-content collapse " data-bs-parent="#sidebar-nav">
                        <li className="nav-item">
                            <Link  to={`/node`} className="nav-link collapsed">
                                <i className="bi bi-circle"></i><span>Node</span>
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link  to={`/telemetry`} className="nav-link collapsed">
                                <i className="bi bi-circle"></i><span>Telemetry</span>
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link  to={`/remote-reset`} className="nav-link collapsed">
                                <i className="bi bi-circle"></i><span>Remote Reset</span>
                            </Link>
                        </li>
                    </ul>
                </li>



                <li className="nav-item">
                    <a className="nav-link collapsed" data-bs-target="#app-management-nav" data-bs-toggle="collapse" href="#">
                        <i className="bi bi-layout-text-window-reverse"></i><span>App Management</span><i className="bi bi-chevron-down ms-auto"></i>
                    </a>
                    <ul id="app-management-nav" className="nav-content collapse " data-bs-parent="#sidebar-nav">
                        <li className="nav-item">
                            <Link  to={`/users`} className="nav-link collapsed">
                                <i className="bi bi-circle"></i><span>Users</span>
                            </Link>
                        </li>
                    </ul>
                </li>

                


                <li className="nav-item">
                    <a className="nav-link collapsed" data-bs-target="#production-nav" data-bs-toggle="collapse" href="#">
                        <i className="bi bi-layout-text-window-reverse"></i><span>Production</span><i className="bi bi-chevron-down ms-auto"></i>
                    </a>
                    <ul id="production-nav" className="nav-content collapse " data-bs-parent="#sidebar-nav">
                        <li className="nav-item">
                            <a href="https://pcba.cloudatik.com" target="_blank" className="nav-link collapsed">
                                <i className="bi bi-circle"></i><span>PCBA Testing</span>
                            </a>
                        </li>
                        <li className="nav-item">
                            <Link  to={`/create-serial`} className="nav-link collapsed">
                                <i className="bi bi-circle"></i><span>Create Serial</span>
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link  to={`/download-content`} className="nav-link collapsed">
                                <i className="bi bi-circle"></i><span>Download Content</span>
                            </Link>
                        </li>
                    </ul>
                </li>


                </>
            )}


            {user.role == "technician"&& (
                <>
                <li className="nav-item">
                    <a className="nav-link collapsed" data-bs-target="#tables-nav" data-bs-toggle="collapse" href="#">
                        <i className="bi bi-layout-text-window-reverse"></i><span>Product Management</span><i className="bi bi-chevron-down ms-auto"></i>
                    </a>
                    <ul id="tables-nav" className="nav-content collapse " data-bs-parent="#sidebar-nav">
                        <li className="nav-item">
                            <Link  to={`/installationv2`} className="nav-link collapsed">
                                <i className="bi bi-lightbulb"></i><span>Installation</span>
                            </Link>
                        </li>
                        {/* <li className="nav-item">
                            <Link  to={`/simcard`} className="nav-link collapsed">
                                <i className="bi bi-circle"></i><span>Simcard</span>
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link  to={`/sensor`} className="nav-link collapsed">
                                <i className="bi bi-circle"></i><span>Sensor</span>
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link  to={`/pump`} className="nav-link collapsed">
                                <i className="bi bi-circle"></i><span>Pump</span>
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link  to={`/som-passed`} className="nav-link collapsed">
                                <i className="bi bi-lightbulb"></i><span>SOM Passed</span>
                            </Link>
                        </li> */}
                        <li className="nav-item">
                            <Link  to={`/app-board-passed`} className="nav-link collapsed">
                                <i className="bi bi-lightbulb"></i><span>App Board Passed</span>
                            </Link>
                        </li>
                    </ul>
                </li>
                <li className="nav-item">
                    <a className="nav-link collapsed" data-bs-target="#production-nav" data-bs-toggle="collapse" href="#">
                        <i className="bi bi-layout-text-window-reverse"></i><span>Production</span><i className="bi bi-chevron-down ms-auto"></i>
                    </a>
                    <ul id="production-nav" className="nav-content collapse " data-bs-parent="#sidebar-nav">
                        <li className="nav-item">
                            <a href="https://pcba.cloudatik.com" target="_blank" className="nav-link collapsed">
                                <i className="bi bi-circle"></i><span>PCBA Testing</span>
                            </a>
                        </li>
                        <li className="nav-item">
                            <Link  to={`/create-serial`} className="nav-link collapsed">
                                <i className="bi bi-circle"></i><span>Create Serial</span>
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link  to={`/download-content`} className="nav-link collapsed">
                                <i className="bi bi-circle"></i><span>Download Content</span>
                            </Link>
                        </li>
                    </ul>
                </li>
                </>
            )}
            
            {user.role == "vendor-pump"&& (
                <li className="nav-item">
                    <a className="nav-link collapsed" data-bs-target="#tables-nav" data-bs-toggle="collapse" href="#">
                        <i className="bi bi-layout-text-window-reverse"></i><span>Product Management</span><i className="bi bi-chevron-down ms-auto"></i>
                    </a>
                    <ul id="tables-nav" className="nav-content collapse " data-bs-parent="#sidebar-nav">
                        <li className="nav-item">
                            <Link  to={`/pump`} className="nav-link collapsed">
                                <i className="bi bi-circle"></i><span>Pump</span>
                            </Link>
                        </li>
                    </ul>
                </li>
            )}
        
            

        </ul>

    </aside>

    )
}

export default Sidebar



{/* <li className="nav-item">
    <Link  to={`/`} className="nav-link collapsed">
        <i className="bi bi-circle"></i><span>Home</span>
    </Link>
</li> */}
{/* <li className="nav-item">
    <Link  to={`/sensor1`} className="nav-link collapsed">
        <i className="bi bi-circle"></i><span>Sensor</span>
    </Link>
</li> */}
{/* <li className="nav-item">
    <Link  to={`/information`} className="nav-link collapsed">
        <i className="bi bi-circle"></i><span>Information</span>
    </Link>
</li> */}
{/* <li className="nav-item">
    <Link  to={`/node-edit`} className="nav-link collapsed">
        <i className="bi bi-circle"></i><span>Node Edit</span>
    </Link>
</li> */}
{/* <li className="nav-item">
    <Link  to={`/sensor-edit`} className="nav-link collapsed">
        <i className="bi bi-circle"></i><span>Sensor Edit</span>
    </Link>
</li> */}